import { Apis } from "libs/apis";

export default function useGetDish() {
  const getDishByUserId = async (dishId: number, setDishData: any) => {
    try {
      const res = await Apis.getDishByIdForHomeCook(dishId);
      setDishData(res.data.data);
    } catch (error) {
      console.error("Error fetching dish details:", error);
    }
  };

  const getFeaturedDish = async (homeCookId: string, setDishData: any) => {
    try {
      const res = await Apis.getFeaturedDish(homeCookId);
      // Convert single object to array format for consistency
      const featuredDish = res.data.data;
      setDishData(Array.isArray(featuredDish) ? featuredDish : [featuredDish]);
    } catch (error) {
      console.error("Error fetching featured dish details:", error);
    }
  };

  return { getDishByUserId, getFeaturedDish };
}
